export interface CarModel {
  imageSrc: string;
  logoSrc: string;
  altText: string;
  carLink: string;
  /** Mantém a proporção natural da logo (evita o achatamento do carrossel). */
  preserveLogoAspect?: boolean;
}
export const carModels: CarModel[] = [
  {
    imageSrc:
      "https://bloblandingpageprd.blob.core.windows.net/toyota/geral/yaris-cross/yaris-cross-card.jpeg",
    logoSrc:
      "https://bloblandingpageprd.blob.core.windows.net/toyota/geral/yaris-cross/logo_yaris_cross.png",
    altText: "Yaris Cross",
    carLink: "/yaris-cross",
    preserveLogoAspect: true,
  },
  {
    imageSrc:
      "https://sablobsitestoyotaprd.blob.core.windows.net/images/Home/Explore%20os%20modelos/card_novocorollacross.webp",
    logoSrc:
      "https://sablobsitestoyotaprd.blob.core.windows.net/images/Shared/logo_novo_corolla-gross.svg",
    altText: "Car model 0",
    carLink: "/corolla-cross",
  },
  {
    imageSrc:
      "https://sablobsitestoyotaprd.blob.core.windows.net/images/Home/Explore%20os%20modelos/card_corolla.webp",
    logoSrc:
      "https://sablobsitestoyotaprd.blob.core.windows.net/images/Shared/Logo_corolla.svg",
    altText: "Car model 1",
    carLink: "/corolla",
  },
  {
    imageSrc:
      "https://sablobsitestoyotaprd.blob.core.windows.net/images/Home/Explore%20os%20modelos/card_hilux.webp",
    logoSrc:
      "https://sablobsitestoyotaprd.blob.core.windows.net/images/Shared/Logo_hilux.svg",
    altText: "Car model 2",
    carLink: "/hilux",
  },
  {
    imageSrc:
      "https://sablobsitestoyotaprd.blob.core.windows.net/images/Home/Explore%20os%20modelos/card_rav4.webp",
    logoSrc:
      "https://sablobsitestoyotaprd.blob.core.windows.net/images/Shared/Logo_RAV4.svg",
    altText: "Car model 3",
    carLink: "/rav4",
  },
  {
    imageSrc:
      "https://sablobsitestoyotaprd.blob.core.windows.net/images/Home/Explore%20os%20modelos/card_sw4.webp",
    logoSrc:
      "https://sablobsitestoyotaprd.blob.core.windows.net/images/Shared/Logo_SW4.svg",
    altText: "Car model 4",
    carLink: "/sw4",
  },
  {
    imageSrc:
      "https://bloblandingpageprd.blob.core.windows.net/toyota/geral/hiace/hiace_card.jpg",
    logoSrc:
      "https://bloblandingpageprd.blob.core.windows.net/toyota/geral/hiace/hiace_logo.png",
    altText: "Hiace",
    carLink: "/hiace",
  },
  {
    imageSrc:
      "https://sablobsitestoyotaprd.blob.core.windows.net/images/Shared/Header/mbl/card_bz4x.png",
    logoSrc:
      "https://sablobsitestoyotaprd.blob.core.windows.net/images/Shared/Header/mbl/Logo_BZ4X.png",
    altText: "bZ4X",
    carLink: "/bz4x",
  },
];
